import 'one-ui-styles';
import '../../ccw-app/src/less/index.less';
import './index.less';
import { Styled, withStyles, useExternalSource } from "direflow-component";
import * as React from 'react';
import { Subject } from 'rxjs';

import { FC, useEffect, useRef, useState } from "react";
import { logger } from "./sdk";

import { Desktop } from "@wxcc-desktop/sdk";
import { Service } from "@wxcc-desktop/sdk-types";

// IE compatibility
import 'one-web-ie11';

// Context provider
import {
  Provider,
} from 'one-ui-provider';

// App component
import {
  App,
} from '../../ccw-app/src/app';

import {
  Log, LogLevel,
} from 'one-log';
import {
  BrowserLogger,
} from 'one-web-logger';

// Redux store
import {
  build,
} from '../../ccw-app/one-store/index';
//import { resolver } from 'one-web-loader';
let app: any;
// set up the logger
const log = new Log("ccw-app", [
  new BrowserLogger(),
], LogLevel.DEBUG);
import { HAServer, HAServerOne } from 'one-server-local-ha';
import {
  Resolver,
} from 'one-core';
import { Disposition } from 'one-model-local';



/**
 * Direflow Widget Properties 
 */
interface WidgetProps {
  wxccStaticResourceUrl: string;
  agentId: string;
  agentName: string;
  agentDnis: string;
  agentAni: string;
  cadVariables: any;
  taskSelected: any;
  taskMap: any;
  taskMapInteraction: any;
  Id: any;
  Dnis: any;
  Ani: any;
  Cv: any;
  Ts: any;
  Tm: any;
  Tmi: any;
}
const removePrefix = (phoneNumber: string) => {
  return phoneNumber.replace(/^\+[0-9]{1,3}(\s|\-)/, "");
}

// Create a subject to emit events when SessionStorage changes
const sessionStorageSubject = new Subject<void>();

// Function to fetch agent state from SessionStorage
const getAgentToken = (): any => {
  
  return (sessionStorage.getItem('accessToken') || 'null');
};
/**
 * 
 * @param props has direflow properties that comes Wxcc desktop layout
 */
const AppData: FC<WidgetProps> = (props) => {

  //Resolver
  const resolver: Resolver = (
    url => url
  );

  //This style is used for scrolling purpose for Patient Assist Gadget.
  const styles = `
        .direflow-overflow-container {
          overflow: auto;
          height: 100%;
        }
        .values__value {
          font-size: 1.0rem !important;
        }

        .md-modal.md-modal--small{
          width: 38.5rem !important;
        }
  `;


  const [ccwAni, setCcwAni] = useState<string>(props.agentAni || '');
  const [wxccStaticResourceUrl, setWxccStaticResourceUrl] = useState<string>(props.wxccStaticResourceUrl || '');
  const [ccwDnis, setCcwDnis] = useState<string>(props.agentDnis || '');

  const [stores, setStores] = useState<any>(null);
  const [propsValues, setPropsValues] = useState<any>(null);
  const [ccwActionType, setCcwActionType] = useState<string>('start');
  const [agentId, setAgentId] = useState<string>(props.Id || '');
  const [isDisconnected, setIsDisconnected] = useState<boolean>(false);
  const [isAgentConsulted, setIsAgentConsulted] = useState<string>('');
  const [agentAccessToken, setAgentAccessToken] = useState<any>(getAgentToken());



  const [agentSessionId, setSessionId] = useState("");
  const [agentProfileId, setProfileId] = useState("");
  const [contacts, setContacts] = useState([] as string[]);
  const [acceptedContacts, setAcceptedContacts] = useState([] as string[]);
  const [sampleInteractionId, setSampleIntId] = useState(
    ""
  );
  const newInteractionId = useRef<any>(null);

  const [buddyAgents, setBuddyAgents] = useState(
    null as Service.Aqm.Contact.BuddyAgentsSuccess | null
  );
  const [vTeam, setVTeam] = useState(
    null as Service.Aqm.Contact.VTeamSuccess | null
  );
  const [assignedContacts, setAssignedContacts] = useState(
    [] as {
      interaction: Service.Aqm.Contact.Interaction;
    }[]
  );


  let epicuserid = sessionStorage.getItem('agentepicuserid')

  useEffect(()=>{
    if(agentAccessToken && epicuserid && stores) {
      stores.dispatch({
        type: "one-state-updateuserid/fetch",
        payload: {
          "epic_user": epicuserid,
          "finesse_user": "",
          "five_nine_user": "",
          "wxcc_user": agentId,
          "access_token": agentAccessToken,
          "force": true
        
      }
    });
    } 
    },[epicuserid,stores])

  /**
   * Check if it is Active call 
   * when ever we reload or change from 
   * one tab to another in Wxcc Agent desktop
   * we call this function.
   */
  const checkActiveCall = async (store: any) => {
    try {
      //Fetching taskMap Object from WxCC Desktop Event
      const taskMap: any = await Desktop.actions.getTaskMap();
      log.debug('checkActiveCall taksMap object', taskMap);
      //Check whether it is Active call by checking the size is > 0
      if (taskMap && taskMap?.size > 0) {
        log.debug('checkActiveCall taksMap object size', taskMap?.size);
        //Fetch the taskMap Object value from Map Object
        const taskMap_value = taskMap.values();
        log.debug('checkActiveCall taksMap object value', taskMap_value);
        //Dispatch taskMap Object to Reducer
        store.dispatch({
          type: "interact-wxcc-set",
          payload: taskMap_value.next().value
        })
      }
      else {
        log.debug('checkActiveCall taksMap object is null', 'Removing session variables');
        //Removing session values if it is not an Active call
        sessionStorage.removeItem("subjectid");
        sessionStorage.removeItem("sourceid");
        sessionStorage.removeItem("ani");
        sessionStorage.removeItem("dnis");
        sessionStorage.removeItem("isAgentConsulted");
        sessionStorage.removeItem("agentepicuserid")
        // Reset WxCC interaction Reducer
        stores.dispatch({
          type: "interact-wxcc-reset",
          payload: ""
        })
      }

    } catch (e:any) {
      log.error('Failed to checkActiveCall Exception:', e);
    }
  }

  /**
   * This useEffect will be called on Widget load
   * This useEffect will set the redux store and
   * subscribe to the WxCC call events
   */
  useEffect(() => {
    log.debug('ON', 'LOAD');

    async function fetchSettings() {
      log.debug('WxCC Static Resource URL:', wxccStaticResourceUrl);
      let config_settings: any;
      try {
        /**
         * Calling init for wxcc
         * This is the first method called to get Desktop Events form WxCC
         */
        init();


        /**
         * Fetching settings config file 
         * dynamically from wxccStaticResourceURL path
         */
        try {
          config_settings = await fetch(`${wxccStaticResourceUrl}settings.json`, {
            method: 'GET',
            mode: 'cors'
          })
          config_settings = await config_settings.json();
        } catch (e: any) {
          log.error('Failed to load settings file Exception:', e);
        }
        log.debug('Settings JSON File:', config_settings);


        //Creating Store
        let prop_values: any = {
          settings: config_settings, log, resolver, agentId,
          static_resource_url: wxccStaticResourceUrl,
          wxcc_Logger: logger,
          desktop: Desktop,
          server: new HAServer(
            config_settings.servers,
            (url: string, error: any) => {
              store.dispatch({
                type: "one-state-errorhandle/set",
                payload: {
                  url: url,
                  error: error,
                  monitor: false
                }
              })
            }
          ),
          serverone: new HAServerOne(
            config_settings.servers,
            (url: string, error: any) => {
              store.dispatch({
                type: "one-state-errorhandle/set",
                payload: {
                  url: url,
                  error: error,
                  monitor: false
                }
              })
            }
          )
        }
        //Creating Store by passing props
        let store: any = build(
          prop_values
        );
        //Setting store and props into useState Hooks
        setStores(store);
        setPropsValues(prop_values);


        /**
         * getCurrentInteractionId for setting interation id
         * subscribeAgentContactDataEvents to subscribe the Agent Contact Events
         * subscribeDialerEvents to subscribe the Dialer Events
         * subscribeScreenpopEvent to subscribe Screen Pop Events
         */
        getCurrentInteractionId();
        subscribeAgentContactDataEvents(store);
        subscribeDialerEvents();
        subscribeScreenpopEvent();

        // Setting agentId into hook
        setAgentId(prop_values.agentId);
        //To fetch the Agents Epic User ID and Panviva ID
        if(agentId) {
          sessionStorage.setItem("wxcc_agentid",agentId);
          store.dispatch({
            type: "one-state-getuserid/fetch",
            payload: {
              agentuserid: agentId,
              
            }
          });
          store.dispatch({
            type: "one-state-getpanvivaid/fetch",
            payload: {
              agentuserid: agentId,
              
            }
          });
          sessionStorageSubject.subscribe(() => {  
            setAgentAccessToken(getAgentToken());    
            store.dispatch({
              type: "one-state-updateuserid/fetch",
              payload: {
                "epic_user": epicuserid,
                "finesse_user": "",
                "five_nine_user": "",
                "wxcc_user": agentId,
                "access_token": agentAccessToken,
                "force": true
              
            }
          });
           });
          
         }
        //To handle Network issues.
        // handleConnectionChange();
        // window.addEventListener("online", handleConnectionChange);
        // window.addEventListener("offline", handleConnectionChange);

        //Check if it is a Active call.
        checkActiveCall(store)
      } catch (e: any) {
        log.debug('Setting Config & Subscribing WxCC Events, Caused Exception:', e);
      }
    }


    //Calling config file & setting WxCC events.
    fetchSettings()


    return () => {
      Desktop.agentContact.removeAllEventListeners();
      Desktop.dialer.removeAllEventListeners();
      Desktop.screenpop.removeAllEventListeners();
      // window.removeEventListener("online", handleConnectionChange);
      // window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);

  const inComingCall = (msg: any, stores: any) => {
    logger.info('Call received to Agent', msg)
    logger.info('Agent received call and Apis are getting invoked', msg);
    setCcwAni(removePrefix(msg?.data?.interaction?.callAssociatedDetails?.ani));
    setCcwDnis(removePrefix(msg?.data?.interaction?.callAssociatedDetails?.dn));
    setCcwActionType('start');

    let modelVisible: boolean = true;
    let cadSubjectid;
    let cadSourceid;
    let consolidated_api_invocation: boolean = propsValues?.settings?.compatible?.consolidated_api_invocation;
    if ((msg?.data?.interaction?.callAssociatedData &&
      msg?.data?.interaction?.callAssociatedData?.subjectId &&
      msg?.data?.interaction?.callAssociatedData?.subjectId?.value !== '') ||
      (msg?.data?.interaction?.callAssociatedData &&
        msg?.data?.interaction?.callAssociatedData?.sourceId &&
        msg?.data?.interaction?.callAssociatedData?.sourceId?.value !== '')) {
      modelVisible = false;
      cadSubjectid = msg?.data?.interaction?.callAssociatedData?.subjectId?.value;
      cadSourceid = msg?.data?.interaction?.callAssociatedData?.sourceId?.value;
    }


    //Reset all cards to Skeleton true on Call Arrive
    let skeletonjson = {
      source_skeleton: true,
      callingDestination_skeleton: true,
      subject_skeleton: true,
    }
    // This will initiate the skeleton loading component
    stores.dispatch({
      type: "one-state-skeleton/set",
      payload: skeletonjson
    });
    //Dispatch InteractionId
    stores.dispatch({
      type: "interact-wxcc-update",
      payload: {
        wxccInteractionId: msg?.data?.interactionId
      }
    });
    //Dispatch Verification popup
    stores.dispatch({
      type: "one-state-choosecaller/set",
      payload: {
        number: msg?.data?.interaction?.callAssociatedDetails?.ani,
        dnis: msg?.data?.interaction?.callAssociatedDetails?.dn,
        visible: modelVisible,
        start: true,
        callId: msg?.data?.interactionId
      }
    });
    //Dispatch Patientlookup and Entitydetails
    if (consolidated_api_invocation) {
      stores.dispatch({
        type: "consolidated-api-one",
        payload: {
          number: msg?.data?.interaction?.callAssociatedDetails?.ani,
          type: "Patient",
          dnis: msg?.data?.interaction?.callAssociatedDetails?.dn,
          subjectid: cadSubjectid !== '' ? cadSubjectid : null,
          sourceid: cadSourceid !== '' ? cadSourceid : null
        }
      });
    } else {
      console.log("Inside else", msg)
      console.log("Inside else fetching data", msg.data)
      console.log("Inside else fetching interaction", msg.data.interaction)
      console.log("Inside else fetching participants", msg.data.interaction.participants)
      if(typeof (msg?.data?.interaction?.participants) === 'object' && msg?.data?.interaction?.participants !== null) {
        console.log("-----Inside if conditiom");
        for (let key in msg.data.interaction.participants) {
          if (msg?.data?.interaction?.participants.hasOwnProperty(key)) {
            if (key === agentId) {
              var name = msg?.data?.interaction?.participants[key].name;
              sessionStorage.setItem("wxcc_userid",name);
              stores.dispatch({
                type: "one-state-headless_wxcc/set",
                payload: {
                  agentrole: msg?.data?.interaction?.participants[key]?.pType,
                  agentname: msg?.data?.interaction?.participants[key]?.name,
                  agentid: msg?.data?.interaction?.participants[key]?.id,
                  agentteam: msg?.data?.interaction?.participants[key]?.teamName,
                  teamid: msg?.data?.interaction?.participants[key]?.teamId,
                  ani: msg?.data?.interaction?.callAssociatedDetails?.ani,
                  dnis: msg?.data?.interaction?.callAssociatedDetails?.dn
                }
              })
              break;
            }
          }
        }
      }
        //Dispatch GetSession based on the Interaction ID
        stores.dispatch({
          type: "one-state-getsession/fetch",
          payload: {
              sessionKey:msg?.data?.interactionId
          }
      });
       //Dispostion for Incoming Calls
       let disp: Disposition = { value: "193" }
       disp.dial_list_uid = msg?.data?.interactionId;
       disp.meta00 = agentId;
       disp.meta01 = "";//need to check for skillname
       disp.meta02 = msg?.data?.interaction?.callAssociatedDetails?.ani;
       disp.meta03 = msg?.data?.interaction?.callAssociatedDetails?.dn;
       disp.meta04 = msg?.data?.interactionId;
       disp.meta05 = 'Incoming Call';
       stores.dispatch({
       type: "store-disposition-code",
       payload: disp
       });
    }
    // Set the Session Values
    sessionStorage.setItem("subjectid", cadSubjectid ? cadSubjectid : null);
    sessionStorage.setItem("sourceid", cadSourceid ? cadSourceid : null);
    sessionStorage.setItem("ani", msg?.data?.interaction?.callAssociatedDetails?.ani);
    sessionStorage.setItem("dnis", msg?.data?.interaction?.callAssociatedDetails?.dn);


  }

  const callEnd = (stores: any, event: string) => {
    logger.info('Call End', 'Triggered');
    if((event === 'eAgentConsultFailed' || event === 'eAgentConsultEnded') && (isAgentConsulted === 'eAgentConsultCreated' || sessionStorage.getItem('isAgentConsulted') === 'eAgentConsultCreated')) return;
    stores.dispatch({
      type: "one-state-subject/reset",
      payload: {

      }
    });
    stores.dispatch({
      type: "one-state-choosecaller/reset",
      payload: {
        visible: false,
        start: false
      }
    });
    // RESET Page to intial screen on Call END
    stores.dispatch({
      type: "one-state-tabs/set",
      payload: "1"
    })
    // Reset WxCC interaction Reducer
    stores.dispatch({
      type: "interact-wxcc-reset",
      payload: ""
    })
    stores.dispatch({
      type:"one-state-selectedsubject/reinit",
    })
    stores.dispatch({
        type:"one-state-selectedsource/reinit",
    })
    //ADPAC-160
    sessionStorage.removeItem("selected");
    sessionStorage.removeItem("subjectid");
    sessionStorage.removeItem("sourceid");
    sessionStorage.removeItem("ani");
    sessionStorage.removeItem("dnis");
    sessionStorage.removeItem("isAgentConsulted");
    sessionStorage.removeItem("agentepicuserid")
    //Reset hooks
    setIsAgentConsulted('')
    logger.info("Gadget got successfully Reset:");
  }


  /**
   * init method for WxCC to setup Desktop Events
   */
  async function init() {
    logger.info('Init method called for Agent:', props.Id)
    await Desktop.config.init();
  }


  const handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";
    console.log('handleConnectionChange::', condition);
    if (condition === "online") {
      const webPing = setInterval(() => {
        fetch("//google.com", {
          mode: "no-cors"
        })
          .then(() => {
            setIsDisconnected(false);
            clearInterval(webPing);
          })
          .catch(error => console.log(error));
      }, 2000);
      return;
    }

    return setIsDisconnected(true);
  };

  const subscribeScreenpopEvent = () => {
    Desktop.screenpop.addEventListener("eScreenPop", (msg: any) => {
      //logger.info(msg)
    });
  };

  const subscribeDialerEvents = () => {
    Desktop.dialer.addEventListener("eOutdialFailed", (msg: any) => {
      //logger.info(msg)
    });
  };

  const subscribeAgentContactDataEvents = (stores: any) => {
    Desktop.agentContact.addEventListener("eAgentContact", (msg: any) => {
      //logger.info("AgentContact eAgentContact: ", msg)
    });
    Desktop.agentContact.addEventListener(
      "eAgentContactAssigned",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentContactAssigned: ", msg);
        setAcceptedContacts([...acceptedContacts, msg.data.interactionId]);
        //logger.info(acceptedContacts);
        console.log('eAgentContactAssigned::', msg);
        //Invoking incoming call
        inComingCall(msg, stores);
      }
    );
    Desktop.agentContact.addEventListener(
      "eAgentContactEnded",
      (msg: Service.Aqm.Contact.AgentContact) => {
        logger.info('Call Got Ended', msg)
        //logger.info("AgentContact eAgentContactEnded: ", msg);
        const idx = acceptedContacts.indexOf(msg.data.interactionId);
        if (idx !== -1) {
          setAcceptedContacts(acceptedContacts.slice(idx, 1));
          //logger.info(acceptedContacts);
        }
      }
    );
    Desktop.agentContact.addEventListener(
      "eAgentContactWrappedUp",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentContactWrappedUp: ", msg)
        logger.info("Agent completed Wrapup: ", msg)
        //CallEnd
        callEnd(stores, 'eAgentContactWrappedUp');
      });
    Desktop.agentContact.addEventListener(
      "eAgentOfferContact",
      (msg: Service.Aqm.Contact.AgentContact) => {
        // logger.info(
        //   "AgentContact eAgentOfferContact: ",
        //   msg.data.interactionId
        // );
        // AUX Sandbox Contact
        setContacts([...contacts, msg.data.interactionId]);
        //logger.info("AgentContact eAgentOfferContact: ", contacts);
      }
    );
    Desktop.agentContact.addEventListener(
      "eAgentOfferContactRona",
      (msg: Service.Aqm.Contact.AgentContact) => {
        // logger.info(
        //   "AgentContact eAgentOfferContactRona: ",
        //   msg.data.interactionId
        // );
        // AUX Sandbox Contact
        const idx = contacts.indexOf(msg.data.interactionId);
        if (idx !== -1) {
          setContacts([
            ...contacts.filter(
              (interactionId) => interactionId !== msg.data.interactionId
            ),
          ]);
          //logger.info("AgentContact eAgentOfferContactRona: ", contacts);
        }
      }
    );
    Desktop.agentContact.addEventListener(
      "eAgentOfferConsult",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentOfferConsult: ", msg)
        console.log('eAgentOfferConsult::', msg);
        //set the value to hook if Agent is eAgentOfferConsult
        setIsAgentConsulted('eAgentOfferConsult');
        sessionStorage.setItem("isAgentConsulted", 'eAgentOfferConsult');
        //Invoking incoming call
        inComingCall(msg, stores);

      });
    Desktop.agentContact.addEventListener(
      "eAgentWrapup",
      (msg: Service.Aqm.Contact.AgentContact) => {

        //logger.info("AgentContact eAgentWrapup: ", msg)
      }
    );
    Desktop.agentContact.addEventListener(
      "eAgentContactHeld",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentContactHeld: ", msg)
      });
    Desktop.agentContact.addEventListener(
      "eAgentContactUnHeld",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentContactUnHeld: ", msg)
      });
    Desktop.agentContact.addEventListener(
      "eCallRecordingStarted",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eCallRecordingStarted: ", msg)
      });
    Desktop.agentContact.addEventListener(
      "eAgentConsultCreated",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentConsultCreated: ", msg)
        console.log('eAgentConsultCreated::', msg);
        //set the value to hook if Agent is eAgentConsultCreated
        setIsAgentConsulted('eAgentConsultCreated');
        sessionStorage.setItem("isAgentConsulted", 'eAgentConsultCreated');
      });
    Desktop.agentContact.addEventListener(
      "eAgentConsultConferenced",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentConsultConferenced: ", msg)
        console.log('eAgentConsultConferenced', msg);
      });
    Desktop.agentContact.addEventListener(
      "eAgentConsultEnded",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentConsultEnded: ", msg)
        console.log('eAgentConsultEnded::', msg);
        //CallEnd
        callEnd(stores, 'eAgentConsultEnded');
      });
    Desktop.agentContact.addEventListener(
      "eAgentCtqCancelled",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentCtqCancelled: ", msg)
      });
    Desktop.agentContact.addEventListener("eAgentConsulting", (msg: any) => {
      //logger.info("AgentContact eAgentConsulting: ", msg)
    });
    Desktop.agentContact.addEventListener(
      "eAgentConsultFailed",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentConsultFailed: ", msg)
        console.log('eAgentConsultFailed', msg);
        //CallEnd
        callEnd(stores, 'eAgentConsultFailed');
      });
    Desktop.agentContact.addEventListener(
      "eAgentConsultEndFailed",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentConsultEndFailed: ", msg)
        console.log('eAgentConsultEndFailed', msg);
      });
    Desktop.agentContact.addEventListener("eAgentCtqFailed", (msg: any) => {
      //logger.info("AgentContact eAgentCtqFailed: ", msg)
    });
    Desktop.agentContact.addEventListener(
      "eAgentCtqCancelFailed",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentCtqCancelFailed: ", msg)
      });
    Desktop.agentContact.addEventListener(
      "eAgentConsultConferenceEndFailed",
      (msg: Service.Aqm.Contact.AgentContact) => {
        //logger.info("AgentContact eAgentConsultConferenceEndFailed: ", msg)
        console.log('eAgentConsultConferenceEndFailed', msg)
      });
    Desktop.agentContact.addEventListener("eAgentConsultConferenceEnded",
      (msg: Service.Aqm.Contact.AgentContact) => {
        console.log('eAgentConsultConferenceEnded', msg)
        //CallEnd
        //callEnd(stores);
      });
  };

  const getCurrentInteractionId = () => {
    let path = window.location.pathname;
    if (path.indexOf("task") >= 0 && path.replace("task/", "").length > 0) {
      setSampleIntId(path.replace("/task/", ""));
      logger.info("getCurrentInteractionId", path.replace("/task/", ""));
      //logger.info("Current interactionID: ", sampleInteractionId);
    }
  };

  const getAgentInfo = () => {
    const latestData = Desktop.agentStateInfo.latestData;
    //logger.info("AgentStateInfo latestData: ", latestData);
    if (latestData.agentProfileID) {
      setProfileId(latestData.agentProfileID);
    }

    if (latestData.subStatus) {
      setSessionId(latestData.subStatus);
    }
  };

  const getClientLocale = () => {
    //logger.info("Client locale: ", Desktop.config.clientLocale);
  };

  async function changeState(s: "Available" | "Idle") {
    const agentState = await Desktop.agentStateInfo.stateChange({
      state: s,
      auxCodeIdArray: "0",
    });
    //logger.info("State Changed", agentState);
  }

  async function getAgentAddressBooks() {
    const books = await Desktop.agentStateInfo.fetchAddressBooks();
    //logger.info("Address books: ", books);
  }

  async function getBuddyAgents() {
    const buddyAgentPayload = {
      agentProfileId: agentProfileId,
      channelName: "chat",
      state: "Available",
    };

    const myBuddyAgents =
      (await Desktop.agentContact.buddyAgents({
        data: buddyAgentPayload,
      })) || null;

    setBuddyAgents(myBuddyAgents);
    //logger.info(buddyAgents);
  }

  async function getVTeamList() {
    const vTeamPayload = {
      agentProfileId: agentProfileId,
      agentSessionId: agentSessionId,
      channelType: "chat",
      type: "inboundqueue",
    };

    const myvTeam =
      (await Desktop.agentContact.vteamList({
        data: vTeamPayload,
      })) || null;

    setVTeam(myvTeam);
    //logger.info(vTeam, vTeam!.data.data.vteamList);
  }

  async function acceptInteraction(interactionId: string) {
    const acceptInteraction = await Desktop.agentContact.accept({
      interactionId: interactionId,
    });
    //logger.info(acceptInteraction);

  }

  async function endInteraction() {
    const endedInteraction = await Desktop.agentContact.end({
      interactionId: sampleInteractionId,
    });
    //logger.info(endedInteraction);
  }

  async function wrapUpInteraction() {
    const wrappedUpInteraction = await Desktop.agentContact.wrapup({
      interactionId: sampleInteractionId,
      data: {
        wrapUpReason: "Example reason here",
        auxCodeId: "0",
        isAutoWrapup: "false",
      },
    });
    //logger.info(wrappedUpInteraction);
  }

  async function consultWithAgent() {
    const consult = await Desktop.agentContact.consult({
      interactionId: sampleInteractionId,
      data: {
        agentId: agentId,
        destAgentId: buddyAgents?.data.agentList[0].agentId,
        mediaType: "chat",
      },
      url: "consult",
    });
    //logger.info(consult);
  }

  async function endConferenceWithAgent() {
    const consult = await Desktop.agentContact.consultEnd({
      interactionId: sampleInteractionId,
      isConsult: false,
    });
    //logger.info(consult);
  }

  async function consultConferenceWithAgent() {
    const consult = await Desktop.agentContact.consultConference({
      interactionId: sampleInteractionId,
      data: {
        agentId: agentId,
        destAgentId: buddyAgents?.data.agentList[0].agentId,
        mediaType: "chat",
      },
    });
    //logger.info(consult);
  }

  async function endConsultConferenceWithAgent() {
    const consult = await Desktop.agentContact.consultEnd({
      interactionId: sampleInteractionId,
      isConsult: true,
    });
    //logger.info(consult);
  }

  async function consultTransferToAgent() {
    if (buddyAgents?.data.agentList[0].agentId) {
      const consult = await Desktop.agentContact.consultTransfer({
        interactionId: sampleInteractionId,
        data: {
          agentId: agentId,
          destAgentId: buddyAgents?.data.agentList[0].agentId,
          mediaType: "chat",
          mediaResourceId: "b102ed10-fac2-4f8e-bece-1c2da6ba6dd8",
        },
      });
      //logger.info(consult);
    } else {
      //logger.info("consultTransferToAgent(): agentId is not defined");
    }
  }

  async function vTeamTransfer() {
    if (
      vTeam?.data.data.vteamList[0].analyzerId &&
      vTeam?.data.data.vteamList[0].type
    ) {
      const consult = await Desktop.agentContact.vteamTransfer({
        interactionId: sampleInteractionId,
        data: {
          vteamId: vTeam?.data.data.vteamList[0].analyzerId,
          vteamType: vTeam?.data.data.vteamList[0].type,
        },
      });
      //logger.info(consult);
    } else {
      if (!vTeam?.data.data.vteamList[0].analyzerId) {
        //logger.info("vTeamTransfer(): analyzerId is not defined");
      }
      if (!vTeam?.data.data.vteamList[0].type) {
        //logger.info("vTeamTransfer(): type is not defined");
      }
    }
  }

  async function getToken() {
    const token = await Desktop.actions.getToken();
    //logger.info(token);
  }

  async function getIdleCodes() {
    const idle = await Desktop.actions.getIdleCodes();
    //logger.info(idle);
  }

  async function getwrapupCodes() {
    const wrapup = await Desktop.actions.getWrapUpCodes();
    //logger.info(wrapup);
  }

  async function getTaskMap() {
    const taskMap = await Desktop.actions.getTaskMap();
    //console.log(taskMap);
    const myAssignedContacts: any = Array.from(taskMap?.values() || []);
    setAssignedContacts(myAssignedContacts);
    //console.log(assignedContacts[0]);
  }

  function setNewInteraactionId() {
    setSampleIntId(newInteractionId.current.value);
  }



  return (
    <>
      {stores && propsValues && (
        <Provider
          store={stores}
          context={propsValues}
        >
          <Styled styles={styles}>
            <div className={'direflow-overflow-container'}>
              <App desktop={Desktop} />
            </div>
          </Styled>
        </Provider>)
      }
      {
        stores === null && propsValues === null && (
          <h5>Loading....</h5>
        )
      }
    </>
  )

}

window.addEventListener('storage', (event) => {
  if(event.storageArea === sessionStorage && event.key === 'accessToken') {
    sessionStorageSubject.next();
  }
})
//export default withStyles(css)(AppData);
export default AppData;



